import React from 'react';
import { X, Type, Image, Layout, Columns, Box, List, MessageSquare, Star, Users, BarChart } from 'lucide-react';
import { Button } from '../components/ui/button';

const componentCategories = {
  'Layout': [
    { type: 'Section', icon: Layout, description: 'Container section with background options' },
    { type: 'Container', icon: Box, description: 'Content container with max-width' },
    { type: 'Columns', icon: Columns, description: 'Multi-column layout' },
    { type: 'Grid', icon: Layout, description: 'Flexible grid layout' },
  ],
  'Content': [
    { type: 'Heading', icon: Type, description: 'H1-H6 heading text' },
    { type: 'Paragraph', icon: Type, description: 'Body text paragraph' },
    { type: 'Image', icon: Image, description: 'Image with caption' },
    { type: 'Hero', icon: Layout, description: 'Hero section with CTA' },
  ],
  'Components': [
    { type: 'Button', icon: Box, description: 'Call-to-action button' },
    { type: 'Card', icon: Box, description: 'Content card' },
    { type: 'FeatureCard', icon: Star, description: 'Feature highlight card' },
    { type: 'Testimonial', icon: MessageSquare, description: 'Customer testimonial' },
    { type: 'Stats', icon: BarChart, description: 'Statistics display' },
    { type: 'FAQ', icon: List, description: 'FAQ accordion' },
    { type: 'CTA', icon: Box, description: 'Call-to-action section' },
    { type: 'ContactForm', icon: MessageSquare, description: 'Contact form' },
  ],
  'Social Proof': [
    { type: 'LogoCloud', icon: Users, description: 'Client/partner logos' },
    { type: 'TeamCard', icon: Users, description: 'Team member card' },
  ]
};

const ComponentLibrary = ({ onAddComponent, onClose, isAddingToContainer = false }) => {
  return (
    <div className="w-80 bg-white border-r border-gray-200 h-full overflow-y-auto">
      <div className="sticky top-0 bg-white border-b px-4 py-3 flex items-center justify-between z-10">
        <h3 className="font-semibold text-gray-900">
          {isAddingToContainer ? 'Add to Container' : 'Components'}
        </h3>
        <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
          <X size={18} />
        </button>
      </div>

      <div className="p-4 space-y-6">
        {Object.entries(componentCategories).map(([category, components]) => (
          <div key={category}>
            <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
              {category}
            </h4>
            <div className="space-y-2">
              {components.map((comp) => {
                const Icon = comp.icon;
                return (
                  <button
                    key={comp.type}
                    onClick={() => onAddComponent(comp.type)}
                    className="w-full flex items-start gap-3 p-3 rounded-lg border border-gray-200 hover:border-primary hover:bg-primary/5 transition-colors text-left"
                  >
                    <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded flex items-center justify-center">
                      <Icon size={16} className="text-gray-600" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">{comp.type}</p>
                      <p className="text-xs text-gray-500">{comp.description}</p>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComponentLibrary;
